import React from 'react'
import {toAbsoluteUrl} from "../../../../helpers";

function RecallHoursText({clinicHours}) {
  return (
    <div className='container'>
        <div className="row">
            <div className="col-8">
                <table className="table table-striped">
                    <tbody>
                    {clinicHours.map((item, index) => (
                        <tr key={index}>
                            <td className='ps-3'>{item.day}</td>

                            <td>
                                <div className="d-flex flex-column">
                                    <span>{item.start} - {item.end}</span>
                                    <span>{item.note}</span>
                                </div>
                            </td>

                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <div className="col-4">
                <img src={toAbsoluteUrl('/media/illustrations/ecx/calendar_8r6s.svg')} className='img-fluid p-5' />
            </div>
        </div>

    </div>
  )
}

export default RecallHoursText